module.exports = __webpack_public_path__ + "img/noticia-08.d99c9e74.png";